<div>
  <div class="flex flex-col sm:flex-row sm:justify-between items-center">
    <form [formGroup]="userFilterForm" class="flex flex-col m-2 sm:flex-row">
      <mat-form-field class="m-2">
        <mat-label>Filter by User Roles</mat-label>

        <mat-select
          (selectionChange)="getUsersWithRole($event)"
          formControlName="role"
        >
          @for (role of userRoles; track role.id ) {
          <mat-option [value]="role.id"> {{ role.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="m-2">
        <mat-label>Filter by Status</mat-label>

        <mat-select
          (selectionChange)="getUsersWithStatus($event)"
          formControlName="status"
        >
          @for (status of statuses; track status ) {
          <mat-option [value]="status"> {{ status }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="m-2">
        <mat-label>Filter by Campus</mat-label>

        <mat-select
          (selectionChange)="getUsersWithCampus($event)"
          formControlName="campus"
        >
          @for (campus of campuses; track campus.id ) {
          <mat-option [value]="campus.id"> {{ campus.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>

    <button
      mat-raised-button
      (click)="openCreateDialog()"
      color="accent"
      class="mr-3"
    >
      Create new User
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="m-5">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      (matSortChange)="sortChange($event)"
      class="mat-elevation-z8"
      matTableResponsive
    >
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
        <td mat-cell *matCellDef="let item">{{ item.firstName }}</td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
        <td mat-cell *matCellDef="let item">{{ item.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let item">{{ item.email }}</td>
      </ng-container>

      <ng-container matColumnDef="userRole">
        <th mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let item">
          {{
            item.userRoles[0] != undefined ? item.userRoles[0].role?.name : ""
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="userProfile.campus.name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Campus</th>
        <td mat-cell *matCellDef="let item">{{ item.userProfile.campus?.name }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let item">{{ item.status }}</td>
      </ng-container>

      <ng-container matColumnDef="manage">
        <th mat-header-cell *matHeaderCellDef>Manage</th>
        <td mat-cell *matCellDef="let vendor">
          <div class="flex-row">
            <button
              mat-mini-fab
              (click)="openEditDialog(vendor)"
              matTooltip="Edit"
              class="mr-2"
            >
              <mat-icon> edit </mat-icon>
            </button>

            <button
              mat-mini-fab
              (click)="openDeleteDialog(vendor)"
              matTooltip="Delete"
            >
              <mat-icon> delete </mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    [length]="totalCount"
    showFirstLastButtons
    aria-label="Select page of colleges"
    (page)="changePage($event)"
  >
  </mat-paginator>
</div>
